import { LearnwareQuestiontypes } from './modules/LearnwareQuestiontypes';
export class Learnware {
    parent;
    type = 'learnware';
    id = 'schlaukopf';
    learnwareQuestiontypes = new LearnwareQuestiontypes(this);
    get app() {
        return this.parent;
    }
    constructor(parent) {
        this.parent = parent;
    }
}
